<template>
  <modal-provider :fullscreen-breakpoint="1100"
                  name="photo-modal"
                  @closed="handleClose"
                  :width="1370"
                  :title="title">
    <div class="photo-modal__container">
      <div class="photo-modal__thumbs custom-scrollbar">
        <PhotoThumbs is-modal />
      </div>
      <div class="photo-modal__body">
        <PhotoSlider
          is-modal
          :current-photo-index="currentPhotoIndex"
          :photos="photos"
          :videos="videos"
          :short-photo-list="shortPhotoList"
          :is360-overview="is360Overview"
        />
        <div class="photo-modal__wrap photo-modal__wrap--with-btns">
          <PriceWithButton class="photo-modal__price" is-modal />
        </div>
      </div>
    </div>
  </modal-provider>
</template>

<script>
import PhotoSlider from './PhotoSlider'
import { mapState, mapActions } from 'vuex'
import PhotoThumbs from './PhotoThumbs'
import PriceWithButton from '../PriceWithButton'

export default {
  name: 'PhotoModal',
  components: {
    PhotoThumbs,
    PhotoSlider,
    PriceWithButton
  },
  computed: {
    ...mapState({
      title: state => state.productInfo.productInfo.title,
      photos: state => state.productInfo.productInfo.photos,
      shortPhotoList: state => state.productInfo.productInfo.shortPhotoList,
      currentPhotoIndex: state => state.productGallery.currentPhotoIndex,
      is360Overview: state => state.productGallery.is360Overview,
      videos: state => state.productInfo.productInfo.videos
    })
  },
  methods: {
    ...mapActions(['SET_360_OVERVIEW_ACTION']),
    handleClose () {
      this.SET_360_OVERVIEW_ACTION(false)
    }
  }
}
</script>
<style scoped lang="sass">

::v-deep
  .modal
    display: flex
    flex-direction: column
    max-height: 100vh
    width: 100%
  .modal-body
    position: relative
    flex-grow: 1
    padding: 0

.photo-modal__container
  display: flex
  flex-direction: column-reverse
  flex-grow: 1
  justify-content: space-between
  padding-bottom: 20px
  position: absolute
  height: 100%
  width: 100%

  +mmin(1100)
    position: relative
    width: auto
    height: auto
    flex-direction: row

  ::v-deep .swiper-item__container
    max-width: 100%
    padding-bottom: min(600px, 100%, 65vh)
    +mmax(1100)
      padding-bottom: 0
      height: 100%

.photo-modal__thumbs
  width: 100%
  max-height: 61px
  z-index: 2

  +mmin(1100)
    position: relative
    bottom: auto
    left: auto
    transform: none
    display: block
    max-height: min(calc(100vh - 130px), 680px)
    overflow: hidden
    overflow-y: auto
    width: 120px

.photo-modal__thumbs-scroll
  margin: 0 auto
  overflow: auto

.photo-modal__body
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: relative
  width: 100%
  height: 100%

  +mmin(1100)
    width: calc(100% - 120px)
    height: auto
    padding-left: 20px
    padding-right: 20px

.photo-modal__wrap
  width: 100%

  &--with-btns
    display: none

    +mmin(1100)
      display: block

.photo-modal__price
  margin: 0 0 0 auto

.modal__close
  z-index: 2
  right: 30px
  top: 30px

  +mmin(1100)
    right: 10px
    top: 10px
</style>
